export type AgeTier = 1 | 2 | 3 | 4 | 5 | 6;

export const getAgeTier = (ageGroup?: string): AgeTier => {
  if (!ageGroup) return 3;
  const g = ageGroup.toLowerCase();
  if (['hatchlings','sparks'].includes(g)) return 1;
  if (['embers','fledglings'].includes(g)) return 2;
  if (['drakes','seekers','sentinels'].includes(g)) return 3;
  if (['wyverns','stormriders'].includes(g)) return 4;
  if (['flamebearers','ascended'].includes(g)) return 5;
  if (['vanguards','mystics','elders'].includes(g)) return 6;
  return 3;
};

export const getPortalLabel = (tier: AgeTier, isActive: boolean, nextStart?: string): string => {
  if (!isActive) {
    const time = nextStart ? ' kl. ' + nextStart : '';
    const labels: Record<AgeTier, string> = {
      1: '⏳ Timen starter snart' + time,
      2: '⏳ Timen starter snart' + time,
      3: '⏳ Lektionen starter' + time,
      4: '⏳ Sessionen starter' + time,
      5: '⏳ Sessionen starter' + time,
      6: '⏳ Mødet starter' + time
    };
    return labels[tier];
  }
  const labels: Record<AgeTier, string> = {
    1: '🟢 Vi er i gang - klik her',
    2: '🟢 Taend for timen nu',
    3: '▶ Start lektionen',
    4: '📹 Start videolektion',
    5: '📹 Start videolektion',
    6: 'Deltag i møde'
  };
  return labels[tier];
};

export const getPortalStyle = (tier: AgeTier, isActive: boolean): string => {
  if (!isActive) return 'w-full bg-gray-700 text-gray-400 py-2 md:py-4 rounded-lg md:rounded-xl font-bold text-[10px] md:text-sm border border-gray-600 cursor-not-allowed';
  const styles: Record<AgeTier, string> = {
    1: 'w-full bg-green-500 hover:bg-green-400 text-white py-3 md:py-5 rounded-xl md:rounded-2xl font-black text-sm md:text-base shadow-[0_0_20px_rgba(34,197,94,0.5)] border-b-4 border-green-700 transition-all animate-pulse',
    2: 'w-full bg-green-600 hover:bg-green-500 text-white py-3 md:py-4 rounded-xl font-black text-sm shadow-lg border-b-4 border-green-800 transition-all',
    3: 'w-full bg-indigo-600 hover:bg-indigo-500 text-white py-2 md:py-4 rounded-lg md:rounded-xl font-bold text-[10px] md:text-sm shadow-lg border-b-2 md:border-b-4 border-indigo-800 transition-all',
    4: 'w-full bg-blue-700 hover:bg-blue-600 text-white py-2 md:py-4 rounded-lg md:rounded-xl font-bold text-[10px] md:text-sm shadow-lg border-b-2 md:border-b-4 border-blue-900 transition-all',
    5: 'w-full bg-violet-700 hover:bg-violet-600 text-white py-2 md:py-4 rounded-lg md:rounded-xl font-bold text-[10px] md:text-sm shadow-lg border-b-2 border-violet-900 transition-all',
    6: 'w-full bg-slate-700 hover:bg-slate-600 text-white py-2 md:py-4 rounded-lg md:rounded-xl font-bold text-[10px] md:text-sm shadow border border-slate-500 transition-all'
  };
  return styles[tier];
};
